export default "__VITE_ASSET__DEpCUHh2__"